import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox';
import PreviewButton from './PreviewButton';

export default class WeeklyDigestConfigurationInput extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    enableDigest: PropTypes.bool.isRequired,
    subjectLine: PropTypes.string.isRequired,
    senderEmail: PropTypes.string.isRequired,
    senderName: PropTypes.string.isRequired,
    previewPath: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      enableDigest: this.props.enableDigest,
      subjectLine: this.props.subjectLine,
      senderEmail: this.props.senderEmail,
      senderName: this.props.senderName,
    };
  }

  enableDigestChange = () => {
    const enableDigest = !this.state.enableDigest;
    this.setState({ enableDigest });
  }

  subjectLineChange = (e) => {
    const subjectLine = e.target.value;
    this.setState({ subjectLine });
  }

  senderEmailChange = (e) => {
    const senderEmail = e.target.value;
    this.setState({ senderEmail });
  }

  senderNameChange = (e) => {
    const senderName = e.target.value;
    this.setState({ senderName });
  }

  renderTextInput(label, hint, id, value, onChange, type = 'text') {
    return (
      <div className="h-12 u-mb-8">
        <label className="string required" htmlFor={id}>{label}</label>
        {hint && <div className="hint">{hint}</div>}
        <input
          id={id}
          type={type}
          value={value}
          onChange={onChange}
        />
      </div>
    );
  }

  render() {
    return (
      <div className="u-mt-6">
        <div className="u-float-right" id="weekly-digest-preview-modal-trigger">
          <PreviewButton
            previewPath={this.props.previewPath}
            previewData={this.state}
            text="Preview Digest" />
        </div>

        <div className="h-12 u-mb-8">
          <label className="string required" htmlFor="enable-digest">Enable weekly digest emails</label>
          <div className="hint">This determines whether digest emails are sent Sunday at 6 PM for your community.</div>
          <Checkbox id="enable-digest" checked={this.state.enableDigest} onChange={this.enableDigestChange} />
        </div>

        {this.renderTextInput('Digest Subject Line', null, 'subject-line', this.state.subjectLine, this.subjectLineChange)}

        {this.renderTextInput('Sender Email', 'The email address that will be the sender for your digests.',
          'sender-email', this.state.senderEmail, this.senderEmailChange, 'email')}

        {this.renderTextInput('Sender Name', 'The sender for your digests; can be your founder, community manager, etc.',
          'sender-name', this.state.senderName, this.senderNameChange)}

        <input name={`${this.props.name}[enable_digest]`} type="hidden" value={this.state.enableDigest} />
        <input name={`${this.props.name}[subject_line]`} type="hidden" value={this.state.subjectLine} />
        <input name={`${this.props.name}[sender_email]`} type="hidden" value={this.state.senderEmail} />
        <input name={`${this.props.name}[sender_name]`} type="hidden" value={this.state.senderName} />
      </div>
    );
  }
}
